import { render, staticRenderFns } from "./reportsCard.vue?vue&type=template&id=1da72f7b&"
import script from "./reportsCard.vue?vue&type=script&lang=js&"
export * from "./reportsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports